import React from 'react';
import { NextPage } from 'next';

import { StaticPageLayout } from '../layouts/static-page.layout';
import { Layout } from '../components/element';
import { TrackingList } from '../components/tracking-list';
import { TrackingForm } from '../components/tracking-form';

const TrackingPage: NextPage = () => (
  <StaticPageLayout wrapperClassName="wrapper__mini" ns="tracking" title="tracking.title">
    <Layout.Row gutter={20} type="flex" justify="center" className="mb-20">
      <Layout.Col span={24} md={10}>
        <img src="/static/pages/tracking/smartpostglobaltracking.svg" alt="" />
      </Layout.Col>
    </Layout.Row>

    <TrackingForm />
    <TrackingList />
  </StaticPageLayout>
);

TrackingPage.getInitialProps = async () => ({
  namespacesRequired: ['common', 'tracking'],
});

export default TrackingPage;
